import React, { useState, useEffect } from "react";
import axios from "../../../utils/axios";
import {
  CALL_PPOR_API,
  MIDDLE_WARE_BASE_URL_v1,
} from "../../../utils/CONSTANTS";
import "./newFeatureannouncement.scss";


export interface Announcement {
  title: string;
  description: string;
  date: string;
}

export interface NewFeatureAnnouncementProps {
  announcements?: Announcement[];
  oracleId?: string;
  country?: string;
  jobFamily?: string;
  fromHeader?: boolean;
  //fromHeader: false;

  onClose?: () => void;
}

const NewFeatureAnnouncement: React.FC<NewFeatureAnnouncementProps> = ({
  announcements: propAnnouncements = [],
  oracleId,
  country,
  jobFamily,
  fromHeader = false,
  onClose,
}) => {
  const [open, setOpen] = useState(true); // Always allow opening from header
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const [toastMsg, setToastMsg] = useState<string | null>(null);
  const [toastType, setToastType] = useState<"success" | "error" | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => { const dontShow = localStorage.getItem("dontShowAnnouncement"); if (dontShow === "true") { setOpen(false); } }, []);

  // Only apply do not show again logic for non-header
  const handleCheckbox = async (checked: boolean) => {
    setDontShowAgain(checked);
    localStorage.setItem("dontShowAnnouncement", checked ? "true" : "false");
    setOpen(!checked);
    if (oracleId) {
      setLoading(true);
      const requestData = {
        action: "UpdateNewFeatureShow",
        newFeature_show: checked ? "Y" : "N",
        oracleId: oracleId,
      };
      try {
        const apiRes = await axios.postStringRequest(
          MIDDLE_WARE_BASE_URL_v1() + CALL_PPOR_API(),
          requestData
        );
        if (apiRes?.data === true) {
          setToastMsg("Success");
          setToastType("success");
        } else {
          setToastMsg("Please try again");
          setToastType("error");
        }
        setTimeout(() => setToastMsg(null), 2500);
      } catch (e) {
        setToastMsg("Please try again");
        setToastType("error");
        setTimeout(() => setToastMsg(null), 2500);
      } finally {
        setLoading(false);
      }
    }
  };

  // Always allow reopening from header
  // Always allow reopening from header
  useEffect(() => {
    if (fromHeader && typeof onClose === "function") {
      setOpen(true);
    }
  }, [fromHeader, propAnnouncements, onClose]); // ✅ added onClose

  // When parent sets showPopup to true, always open
  useEffect(() => {
    if (fromHeader && open === false && typeof onClose === "function") {
      setOpen(true);
    }
  }, [fromHeader, open, onClose]); // ✅ added onClose


  // Debug log for header popup announcements
  useEffect(() => {
    if (open && fromHeader) {
      console.log('Header popup announcements:', propAnnouncements);
    }
  }, [open, fromHeader, propAnnouncements]);

  // Determine if popup should show (ProfileLanding: only for 2 weeks, Header: always)
  let showPopup = true;
  let displayAnnouncements = propAnnouncements;
  if (!fromHeader) {
    if (propAnnouncements.length > 0) {
      const latest = propAnnouncements.reduce((a, b) => new Date(a.date) > new Date(b.date) ? a : b);
      const releaseDate = new Date(latest.date);
      const now = new Date();
      const diffDays = (now.getTime() - releaseDate.getTime()) / (1000 * 60 * 60 * 24);
      showPopup = diffDays <= 14;
      // Only show announcements if within 2 weeks
      if (!showPopup) displayAnnouncements = [];
    } else {
      showPopup = false;
      displayAnnouncements = [];
    }
  }

  const handleClose = () => {
    setOpen(false);
    if (typeof onClose === "function") onClose();
  };

  if (!open || (!showPopup && !fromHeader)) return null;

  return (
    <div className="nfa-modal">
      <div className="nfa-content">
        <button className="nfa-close" onClick={handleClose}>
          ×
        </button>
        <h2 className="nfa-title">What's New in TTEC Connect?</h2>
        <div className="nfa-image-row">
          <img
            src="/images/banners/images/NewFeature_banner.png"
            alt="New Feature Banner"
            className="nfa-illustration"
            style={{ width: "100%", borderRadius: 12, marginBottom: 16 }}
          />
        </div>
        <div className="nfa-list">
          {displayAnnouncements.length === 0 ? (
            <div style={{ textAlign: "center", fontSize: "1.1em", color: "#888", margin: "32px 0" }}>
              No new announcements.
            </div>
          ) : (
            <table className="nfa-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Release Date</th>
                </tr>
              </thead>
              <tbody>
                {displayAnnouncements.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.title}</td>
                    <td>{item.description}</td>
                    <td>{item.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {!fromHeader && (
          <div style={{ marginTop: 18, textAlign: "right" }}>
            <label style={{ fontSize: "1rem", cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={(e) => handleCheckbox(e.target.checked)}
                style={{ marginRight: 8 }}
                disabled={loading}
              />
              Do not show this again
              {loading && (
                <span style={{ marginLeft: 10, fontSize: 14 }}>
                  <span
                    className="nfa-spinner"
                    style={{
                      display: "inline-block",
                      width: 18,
                      height: 18,
                      border: "2px solid #2a7be4",
                      borderTop: "2px solid #fff",
                      borderRadius: "50%",
                      animation: "nfa-spin 1s linear infinite",
                      verticalAlign: "middle",
                    }}
                  />
                </span>
              )}
            </label>
          </div>
        )}
        {toastMsg && (
          <div
            style={{
              marginTop: 16,
              textAlign: "center",
              color: toastType === "success" ? "#2a7be4" : "#d32f2f",
              fontWeight: 600,
              fontSize: "1.05rem",
            }}
          >
            {toastMsg}
          </div>
        )}
      </div>
    </div>
  );
};

export default NewFeatureAnnouncement;

/*
Add spinner animation @keyframes nfa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
*/